<template lang="pug">
  .component-move-asset
    button.button.small(@click="moveEnabled = !moveEnabled") Move
    .content(v-if="moveEnabled")
      .close-button(@click="moveEnabled = false") x
      h2 Select the parking slot
      selectize-grouped-parking-assets(@parkingSlotSelected="parkingSlotSelected")
      .button-group
        button.button(v-if="parking_slot_id", @click="move") Move
    //modal-reveal(sizing="small", ref="modalMoveAsset")
      button.button.small(slot="trigger") Move


</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'
  import SelectizeGroupedParkingAssets from '../../lists/selectize/SelectizeGroupedParkingAssets'

  export default {
    name: 'MoveAsset',
    components: {SelectizeGroupedParkingAssets, ModalReveal},
    data() {
      return {
        parking_slot_id: null,
        moveEnabled: false
      }
    },
    methods: {
      parkingSlotSelected(val) {
        this.parking_slot_id = val.id
      },
      move() {

        this.$confirm('Are you sure?', `Do you really want to move ${this.item.name} (VS-${this.item.id})?`, () => {

          var body = {parking_slot_id: this.parking_slot_id}
          KeplerBackofficeSdk.vehicleSlots.select(this.item.id).move(body, (data) => {
            this.$emit('assetMoved', this.item)
            this.moveEnabled = false
            MaggieHelper.notification('move-esit', 'Vehicle slot moved sucessfully')
          })
        })

      }
    },
    created() {
    },
    props: ['item']

  }
</script>

<style lang="sass">
  .component-move-asset
    .content
      display: flex
      justify-content: center
      flex-direction: column
      height: 100%
      position: absolute
      top: 0
      left: 0
      right: 0
      background: white
      z-index: 1
</style>



// WEBPACK FOOTER //
// MoveAsset.vue?fba4db84